import React, {useState} from 'react'
import gql from 'graphql-tag'
import {Radio} from 'antd'

import EstateList, {ESTATE_FRAGMENT} from './EstateList'
import EstateSearch from './EstateSearch'

import Query from 'components/shared/Query'
import Heading from 'components/shared/Heading'

import './index.scss'

const MY_ESTATES_QUERY = gql`
  query Estates {
    viewer {
      id
      broker {
        id
        myEstates {
          ...Estate
        }
      }
    }
  }
  ${ESTATE_FRAGMENT}
`

const ALL_ESTATES_QUERY = gql`
  query Estates {
    viewer {
      id
      broker {
        id
        estates {
          ...Estate
        }
      }
    }
  }
  ${ESTATE_FRAGMENT}
`

const Estates = () => {
  const [searchActive, setSearchActive] = useState(false)
  const [limitToBrokerEstates, setLimitToBrokerEstates] = useState(true)

  const enableSearch = () => setSearchActive(true)
  const disableSearch = () => setSearchActive(false)

  const changeFilter = (evt) => setLimitToBrokerEstates(evt.target.value === 'true')

  return (
    <section>
      <>
        <Heading>Oppdrag</Heading>

        <EstateSearch
          enableSearch={enableSearch}
          disableSearch={disableSearch}
        />

        {!searchActive && (
          <>
            <Radio.Group
              value={limitToBrokerEstates.toString()}
              onChange={changeFilter}
              className="filter-selector"
            >
              <Radio.Button value="true">MINE OPPDRAG</Radio.Button>
              <Radio.Button value="false">ALLE OPPDRAG</Radio.Button>
            </Radio.Group>

            {limitToBrokerEstates && (
              <Query
                inlineError
                inlineLoading
                query={MY_ESTATES_QUERY}
              >
                {({getData, loading}) => {
                  const estates = (getData('viewer.broker.myEstates.edges') || []).map(edge => edge.node)

                  return (
                    <EstateList
                      estates={estates}
                    />
                  )
                }}
              </Query>
            )}
            {!limitToBrokerEstates && (
              <Query
                inlineError
                inlineLoading
                query={ALL_ESTATES_QUERY}
              >
                {({getData, loading}) => {
                  const estates = (getData('viewer.broker.estates.edges') || []).map(edge => edge.node)

                  return (
                    <EstateList
                      estates={estates}
                      showBroker
                    />
                  )
                }}
              </Query>
            )}
          </>
        )}
      </>
    </section>
  )
}

export default Estates
